/** Retry / recovery policy for storefront media (category cards, product thumbs). */

export const CATALOG_RETRY_DELAYS_MS = [600, 1400, 2800, 5000] as const;
export const DEFAULT_RETRY_DELAYS_MS = [500, 1400] as const;
export const MEDIA_RECOVERY_MAX_ROUNDS = 2;

export function mediaRetryDelays(isCatalogTile: boolean): readonly number[] {
  return isCatalogTile ? CATALOG_RETRY_DELAYS_MS : DEFAULT_RETRY_DELAYS_MS;
}

export function mediaRetryMaxAttempts(isCatalogTile: boolean): number {
  return mediaRetryDelays(isCatalogTile).length;
}

export function mediaRetryDelayMs(isCatalogTile: boolean, attemptIndex: number): number {
  const delays = mediaRetryDelays(isCatalogTile);
  if (!delays.length) {
    return 1000;
  }
  const index = Math.min(Math.max(0, attemptIndex), delays.length - 1);
  return delays[index];
}

export type MediaRecoverySource = 'variant' | 'original';

/**
 * Keep variants first so congestion does not dump raw PNG/JPEG.
 * After most catalog attempts fail, try the original upload once, then variants again.
 */
export function mediaRecoverySource(
  isCatalogTile: boolean,
  attemptIndex: number,
  hasOriginal: boolean
): MediaRecoverySource {
  if (!isCatalogTile || !hasOriginal) {
    return 'variant';
  }
  const lastOriginalAttempt = mediaRetryMaxAttempts(true) - 2;
  return attemptIndex === lastOriginalAttempt ? 'original' : 'variant';
}

export function shouldAllowAnotherRecoveryRound(round: number): boolean {
  return round < MEDIA_RECOVERY_MAX_ROUNDS;
}
